var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "53px",
    height: "53px",
    viewBox: "0 0 53 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5,52.5 C12.1405965,52.5 0.5,40.8594035 0.5,26.5 C0.5,12.1405965 12.1405965,0.5 26.5,0.5 C40.8594035,0.5 52.5,12.1405965 52.5,26.5 C52.5,40.8594035 40.8594035,52.5 26.5,52.5 Z M35.8882686,28.4835218 C33.5219413,26.1316242 31.4711251,28.8755061 30.0513282,30.2866447 C27.0539803,28.718713 23.9777559,25.974831 22.6368368,22.9173613 C26.9751025,18.9975305 26.1074499,18.527151 21.2170399,13.9017495 C18.7718363,11.5498505 16.7998964,14.372129 15.3012231,15.8616656 C14.5124469,16.6456315 14.1180595,17.5863905 14.0391818,18.6055475 C13.2504055,25.6612432 24.5298989,38.439894 33.5219413,38.9886702 C36.2037782,39.1454633 37.2291863,37.6559282 39.1222484,35.6960121 C40.305412,34.5200632 40.305412,32.8737335 39.0433707,31.6977847 L35.8882686,28.4835218 Z M30.5772821,16.5359749 L33.13702,18.9229692 L29.3586545,22.9747701 L30.790775,24.1882824 L34.5997274,20.2869659 L37.1594654,22.6739601 L36.9099918,16.3432315 L30.5772821,16.5359749 Z",
    id: "Combined-Shape",
    fill: "#8A8585",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallBack);
export default __webpack_public_path__ + "static/media/callBack.fb16b6988cbb98ae6ca5bd1e55e79464.svg";
export { ForwardRef as ReactComponent };